export const dealerPath = (slug?: string) => `/dealers/${slug}`;
